import { useGetCustomerReportQuery } from '@/features/slice/report';
import { jsonToCsv } from '@/utils/json-to-csv.util';
import { mapCustomerReportListToCsvExport } from '@/utils/mappers';

export const useCustomerReport = () => {
    const { data, isLoading, isError, isFetching, error } =
        useGetCustomerReportQuery({});

    const handleExportToPdf = () => {
        alert('Not implemented yet');
    };

    const handleExportToCSV = () => {
        jsonToCsv(
            mapCustomerReportListToCsvExport(data?.data ?? []),
            'customer_report.csv',
        );
    };

    return {
        handleExportToCSV,
        handleExportToPdf,

        data,
        isLoading,
        isError,
        isFetching,
        error,
    };
};
